import { FunctionComponent } from "react";
import styles from "./FilterTitle.module.css";
import images from "../../../../assets/images";

interface props {
  handleCloseFilterDropDown: () => void
}
const FilterTitle: FunctionComponent<props> = ({handleCloseFilterDropDown}) => {
  const {CloseIcon} = images;
  return (
    <div className={styles.title}>
      <b className={styles.filter}>Filter</b>
      <div className={styles.closeicon}>
            <img src={CloseIcon} alt="closeicon" onClick={handleCloseFilterDropDown} />
      </div>
    </div>
  );
};

export default FilterTitle;
